import { Injectable } from '@angular/core';
import { RequestService } from '../../../handlers/request/request.service';
import { globalEnv } from '../../connection/global/global.env';
import { prime } from '../../api/prime/prime.api';
import { Observable, of } from 'rxjs';
import { IdCustomerWebSafe } from '../../models/shared/requests/id-customer-web-safe';
@Injectable({
  providedIn: 'root'
})
export class PrimeService {
  constructor(private req: RequestService) { }



  cancelSubscription() {
    return {
      "code": 200,
      "status": "SUCCESS"
    }
  }

  changePaymentMethod() {
    return {
      "code": 200,
      "status": "SUCCESS"
    }
  }

  getPrimeCart() {
    return {
      "active": true,
      "savings": 9000.0,
      "missing_purchase": 5000,
      "minimum_purchase": 20000.0
    }
  }

  getCustomerPrimeCart(customerId, params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${prime.customerEndpoint}${customerId}/${prime.cart}`, params, null, true, true);
  }

  changePrimePaymentMethod(customerId, creditCardId): Observable<any> {
    const env = `https://${globalEnv.be2.split('/')[2]}/`;
    return this.req.patch(`${env}${prime.creditCard}${customerId}/${creditCardId}`, false);
  }

  primeCancel(customerId) {
    const env = `https://${globalEnv.be2.split('/')[2]}/crm/v3/`;
    return this.req.put(`${env}${prime.customer}${customerId}/${prime.cancel}`, false);
  }

  getPrimeSubscription(customerId:number,idCustomerWebSafe: IdCustomerWebSafe): Observable<any> {
    if (!idCustomerWebSafe || !customerId) {      
      return of({ active: false })
    }else{
      const params = {
       idCustomerWebSafe
      };
      return this.req.get(`${globalEnv.be2}${prime.subscription}`, params,null, false, false);
    }
  }

  primeSubscriptionFree(data): Observable<any> {
    return this.req.post(`${globalEnv.be2}${prime.subscriptionFree}`, data, null, true, true);
  }

  getTermsAndConditionsPrimeV1(): Observable<any> {
    return this.req.get(`${globalEnv.multiCountry}${prime.getTerms}`, null, null, true);
  }

  getPrimeStripHome(data){
    return this.req.post(`${globalEnv.gateway}${prime.primeStrip}`, data);
  }

}
